import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesEntrePlayaCaladoActions'
import TablaCamionesEntrePlayaCaladoView from '../components/TablaCamionesEntrePlayaCaladoView'

function TablaCamionesEntrePlayaCalado (props) {
  const { actualizarDatosParaMuiTable, filtroInicial } = props

  useEffect(() => {
    actualizarDatosParaMuiTable(filtroInicial)
  }, [actualizarDatosParaMuiTable, filtroInicial])

  return <TablaCamionesEntrePlayaCaladoView />
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCamionesEntrePlayaCalado)
